import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as Actions from 'protections/actions/protectionsActions.js';
import Protections from 'protections/components/Protections/Protections.jsx';

function mapStateToProps(state) {
    const protections = state.protections;
    const purchaseMethods = state.purchaseMethods;
    const isLease = purchaseMethods.lease.selected;
    const selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    const taxesFactor = purchaseMethods.taxesFactor;
    const taxCodes = purchaseMethods.getTaxCodesString();

    return {
        isLease,
        selectedFinanceTerm,
        taxesFactor,
        taxCodes,
        protections,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Protections);



// WEBPACK FOOTER //
// ./src/containers/Protections/Protections.js